 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLEPAGE from '@/components/Text/TitlePage'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import TEXTDISCLAIMER from '@/components/Text/Disclaimer'
 import TEXTTOC from '@/components/Text/TOC'
 import TEXTOTHERBOOKS from '@/components/Text/OtherBooks'
 import TEXTACK from '@/components/Text/Ack'
 import TEXTOPENING from '@/components/Text/Opening'
 import TEXTPARTONE from '@/components/Text/PartOne'
 import TEXTCHAPTER_001 from '@/components/Text/Chapter_001'
 import TEXTCHAPTER_002 from '@/components/Text/Chapter_002'
 import TEXTCHAPTER_003 from '@/components/Text/Chapter_003'
 import TEXTCHAPTER_004 from '@/components/Text/Chapter_004'
 import TEXTPARTTWO from '@/components/Text/PartTwo'
 import TEXTCHAPTER_005 from '@/components/Text/Chapter_005'
 import TEXTCHAPTER_006 from '@/components/Text/Chapter_006'
 import TEXTCHAPTER_007 from '@/components/Text/Chapter_007'
 import TEXTCHAPTER_008 from '@/components/Text/Chapter_008'
 import TEXTCHAPTER_009 from '@/components/Text/Chapter_009'
 import TEXTCHAPTER_010 from '@/components/Text/Chapter_010'
 import TEXTCHAPTER_011 from '@/components/Text/Chapter_011'
 import TEXTCHAPTER_012 from '@/components/Text/Chapter_012'
 import TEXTCHAPTER_013 from '@/components/Text/Chapter_013'
 import TEXTCHAPTER_014 from '@/components/Text/Chapter_014'
 import TEXTCHAPTER_015 from '@/components/Text/Chapter_015'
 import TEXTCHAPTER_016 from '@/components/Text/Chapter_016'
 import TEXTCHAPTER_017 from '@/components/Text/Chapter_017'
 import TEXTCHAPTER_018 from '@/components/Text/Chapter_018'
 import TEXTCHAPTER_019 from '@/components/Text/Chapter_019'
 import TEXTCHAPTER_020 from '@/components/Text/Chapter_020'
 import TEXTCHAPTER_021 from '@/components/Text/Chapter_021'
 import TEXTCHAPTER_022 from '@/components/Text/Chapter_022'
 import TEXTPARTTHREE from '@/components/Text/PartThree'
 import TEXTCHAPTER_023 from '@/components/Text/Chapter_023'
 import TEXTCHAPTER_024 from '@/components/Text/Chapter_024'
 import TEXTEPILOGUE from '@/components/Text/Epilogue'
 import LOVE_2 from '@/components/love_2'
 import TEXTCTA from '@/components/Text/CTA'
 import TEXTSTEVEJACKSONOTHERBOOKS_V1 from '@/components/Text/STEVEJACKSONotherbooks_v1'
 import TEXTROUGHTRADE_EXCERPT_AD from '@/components/Text/ROUGHTRADE_excerpt_Ad'
 import TEXTCLOCKWORKMURDER_EXCERPT_AD from '@/components/Text/CLOCKWORKMURDER_excerpt_Ad'
 import TEXTTRUECRIMEADPAGE4 from '@/components/Text/TrueCrimeAdPage4'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/TOC",
 			"name" : "Text/TOC",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/OtherBooks",
 			"name" : "Text/OtherBooks",
 			"component" : TEXTOTHERBOOKS
 		},
 		{
 			"path" : "/Text/Ack",
 			"name" : "Text/Ack",
 			"component" : TEXTACK
 		},
 		{
 			"path" : "/Text/Opening",
 			"name" : "Text/Opening",
 			"component" : TEXTOPENING
 		},
 		{
 			"path" : "/Text/PartOne",
 			"name" : "Text/PartOne",
 			"component" : TEXTPARTONE
 		},
 		{
 			"path" : "/Text/Chapter_001",
 			"name" : "Text/Chapter_001",
 			"component" : TEXTCHAPTER_001
 		},
 		{
 			"path" : "/Text/Chapter_002",
 			"name" : "Text/Chapter_002",
 			"component" : TEXTCHAPTER_002
 		},
 		{
 			"path" : "/Text/Chapter_003",
 			"name" : "Text/Chapter_003",
 			"component" : TEXTCHAPTER_003
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js